import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { SearchInputModel } from '@libs/shop/models';

@Component({
  selector: 'ui-product-list-filter',
  templateUrl: './product-list-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./product-list-filter.component.scss'],
})
export class ProductListFilterComponent {
  public searchParams: InputSignal<SearchInputModel> = input.required();
}
